@if(canCalculateDelta)
{
<span class="tabular-nums" [ngClass]="deltaClass" [title]="titleText">
    {{ formattedDelta }}
</span>
}
@else {
<span class="tabular-nums" ngClass="text-neutral-700">
    n/a
</span>
}